module.exports = __webpack_public_path__ + "static/media/pass.f5dfc718.png";